import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import Receive from "@/pages/Receive";
import Become from "@/pages/Become";
import Lineage from "@/pages/Lineage";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import EventsList from "@/pages/events/EventsList";
import EventDetail from "@/pages/events/EventDetail";
import SocialsAdmin from "@/pages/events/SocialsAdmin";

// Shared with the build-time prerender (scripts/prerender.js).
export const AppRoutes = () => (
  <Routes>
    <Route element={<SiteLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/receive" element={<Receive />} />
      <Route path="/become" element={<Become />} />
      <Route path="/lineage" element={<Lineage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Route>
    <Route path="/events" element={<EventsList />} />
    <Route path="/socials/:slug" element={<EventDetail />} />
    <Route path="/socials/admin" element={<SocialsAdmin />} />
  </Routes>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#F4EEE3",
            color: "#161310",
            border: "1px solid #161310",
            borderRadius: 0,
            fontFamily: "Jost, sans-serif",
            fontWeight: 300,
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
